export enum MessageType {
    Init = 'init',
    OpenDoc = 'openDoc',
    CreateDoc = 'createDoc',
    CreateDir = 'createDir',
    CopyDoc = 'copyDoc',
    GetPageInfo = 'getPageInfo',
}

export const msgIdPrefix = 'kujssdk-';
